import { heroEquipment } from "../HeroEquipment";

export const łowcyCzarownic = {
  heroes: {
    Inkwizytor: {
      id: 0,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Łowcy czarownic"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Arcykapłan",
        "Czarostwo",
        "Duchowny (modlitwy do Sigmara)",
        "Dowodzenie",
        "Dowódca",
        "Modlitwa",
        "Nienawiść",
        "Rozproszenie magii (2)",
      ],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    "Prezbiter Sigmara": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Łowcy czarownic"].Prezbiter,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarostwo",
        "Duchowny (modlitwy do Sigmara)",
        "Modlitwa",
        "Nienawiść",
        "Przepastne trzewia",
        "Rozproszenie magii (2)",
      ],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Łowca czarownic": {
      id: 2,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 25,
      number: 3,
      equipmentList: heroEquipment["Łowcy czarownic"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Spalić wiedźmę!"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Zelota: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 99,
      equipmentList: heroEquipment["Łowcy czarownic"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści"],
    },
    Flagelant: {
      id: 4,
      startingEquipment: ["Cep bojowy"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Łowcy czarownic"].Flagelant,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 4, 1, 3, 1, 10],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Fanatyk", "Furia"],
    },
    "Pies bojowy": {
      id: 5,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 4, 3, 1, 4, 1, 5],
        Maksymalna: [6, 4, 0, 4, 3, 1, 4, 1, 5],
      },
      rules: ["Sfora", "Zwierzę"],
    },
    "Rycerz zakonny": {
      id: 6,
      startingEquipment: ["Sztylet", "Miecz", "Koń bojowy", "Siodło & uprząż"],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Łowcy czarownic"].Rycerz,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Duży cel (wierzchem)",
        "Kawalerzysta",
        "Szermierz",
        "Zabójczy cios",
      ],
    },
    Pokutnik: {
      id: 7,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Powóz": ["-","-","-",4,8,8,"-","-","-"],
        "Koń": [8,3,0,3,"-","-",3,1,5],
        "Koń ": [8,3,0,3,"-","-",3,1,5]
      },
      rules: ["Duży cel", "Machina wojenna", "Pokutnik", "Powóz", "Strach"],
      exp: 0,
      skills: [],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Łowcy czarownic",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Podatek", "Rozrzutność"],
  mercenaries: [
    "Kartograf",
    "Kupiec",
    "Łowca nagród",
    "Medyk",
    "Pogromca Trolli",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Tileański kusznik",
    "Woźnica",
    "Zwiadowca",
  ],
};
